<template>
  <div
    class="flex gap-4 flex-wrap text-gray-600"
  >
    <button
      v-if="productType === 'LIGHT'"
      :class="btnClass"
      @click="upgradeToBasic()"
    >
      <fa :icon="faAngleUp" />
      {{ $t('components.company.manualUpgrade.upgradeButton', { productType: basicProductType }) }}
    </button>

    <button
      v-if="productType !== 'EXPERT'"
      :class="btnClass"
      @click="upgradeToExpert()"
    >
      <fa :icon="faAngleDoubleUp" />
      {{ $t('components.company.manualUpgrade.upgradeButton', { productType: expertProductType }) }}
    </button>
  </div>
</template>

<script>
import { faAngleUp, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons'
import UPGRADE_COMPANY_MANUALLY_TO_BASIC from '@/graphql/UpgradeCompanyManuallyToBasic.gql'
import UPGRADE_COMPANY_MANUALLY_TO_EXPERT from '@/graphql/UpgradeCompanyManuallyToExpert.gql'
import feature from '@/mixins/feature'
import ConfirmDialog from '@/components/modals/confirm-dialog.vue'
import branding from '@/mixins/branding'

export default {
  mixins: [feature, branding],
  props: {
    companyId: {
      type: String,
      required: true
    },
    productType: {
      type: String,
      required: true
    },
    btnClass: {
      type: String,
      default: 'btn-danger'
    }
  },
  data () {
    return {
      faAngleUp,
      faAngleDoubleUp
    }
  },
  computed: {
    isSmgPlatform () {
      return this.platform?.toLowerCase() === 'smg'
    },
    isBillwerFeatureActive () {
      return this.isFeatureActive(this.featureNames.BILLWERK)
    },
    basicProductType () {
      return this.isSmgPlatform ? 'PRO' : 'BASIC'
    },
    expertProductType () {
      return this.isSmgPlatform ? 'PRO+' : 'EXPERT'
    }
  },
  methods: {
    async upgradeToExpert () {
      const message = this.isBillwerFeatureActive
        ? this.$t('components.company.manualUpgrade.upgradeTo', { productType: this.expertProductType })
        : this.$t('components.company.manualUpgrade.upgradeToSimple', { productType: this.expertProductType })

      this.$modal.show(
        ConfirmDialog,
        {
          headerText: this.$t('components.company.manualUpgrade.upgradeHeader', { productType: this.expertProductType }),
          action: 'upgrade',
          message,
          onConfirm: async () => {
            await this.$apollo.mutate({
              mutation: UPGRADE_COMPANY_MANUALLY_TO_EXPERT,
              variables: {
                companyId: this.companyId
              }
            })
            this.$router.go(0)
          }
        },
        { height: 'auto', scrollable: true }
      )
    },
    async upgradeToBasic () {
      const message = this.isBillwerFeatureActive
        ? this.$t('components.company.manualUpgrade.upgradeTo', { productType: this.basicProductType })
        : this.$t('components.company.manualUpgrade.upgradeToSimple', { productType: this.basicProductType })

      this.$modal.show(
        ConfirmDialog,
        {
          headerText: this.$t('components.company.manualUpgrade.upgradeHeader', { productType: this.basicProductType }),
          action: 'upgrade',
          message,
          onConfirm: async () => {
            await this.$apollo.mutate({
              mutation: UPGRADE_COMPANY_MANUALLY_TO_BASIC,
              variables: {
                companyId: this.companyId
              }
            })
            this.$router.go(0)
          }
        },
        { height: 'auto', scrollable: true }
      )
    }
  }
}
</script>
